// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"1d0a088d","457":"45b5732b","866":"45b5732b","993":"c0eb0a93"}[chunkId] + ".chunk.css";
};